import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ModalWindowController } from '@reconcept-platform/shared/ui/core/modal';
import { ButtonComponent, ButtonContainerComponent } from '@reconcept-platform/shared/ui/standalone/button';
import { InfoBoxComponent } from '@reconcept-platform/shared/ui/standalone/info-box';
import {
  ModalContentComponent,
  ModalFooterComponent,
  ModalHeaderComponent,
} from '@reconcept-platform/shared/ui/standalone/modal';

@Component({
  selector: 'confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  imports: [
    TranslatePipe,
    ButtonContainerComponent,
    ButtonComponent,
    ModalHeaderComponent,
    ModalContentComponent,
    ModalFooterComponent,
    InfoBoxComponent,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ConfirmationModalComponent {
  self = inject(ModalWindowController);

  @Input() title: string;
  @Input() description: string;
  @Input() alert: string;

  // cancel button
  @Input() cancelButtonText: string;
  @Input() hideCancelButton: boolean;

  // cancel with result button
  @Input() cancelWithResult: boolean;
  @Input() cancelWithResultButtonText: string;

  // confirm button
  @Input() confirmButtonText: string;
  @Input() confirmButtonClass: 'primary' | 'negative' | 'positive' = 'primary';
}
